import { showAlert } from "../alert/alertActions";
import { showLoader, hideLoader } from "../loader/loaderActions";
import Api from "../../service/api";
import { history, getState } from "../configure/configureStore";
import { actionTypes } from "./masterReducer";

// console.log("actionTypes", actionTypes);

//---------------- Update Rows per page
export function updateRowsPerPage(rows) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_ROW_SUCCESS,
      payload: {
        showRowsPerPage: rows,
      },
    });
  };
}

export function getRoleList() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_ROLE_LIST_PENDING,
      payload: {
        roleList: null,
      },
    });
    dispatch(showLoader());

    Api.get("masterData/roleList")
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_ROLE_LIST_SUCCESS,
          payload: {
            roleList: response.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_ROLE_LIST_ERROR,
          payload: {
            roleList: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to fetch roles",
          })
        );
      });
  };
}

export function getCategoryList() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_CATEGORY_LIST_PENDING,
      payload: {
        categories: null,
      },
    });
    dispatch(showLoader());

    Api.get("masterData/categoryList")
      .then((response) => {
        // console.log("categories", response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_CATEGORY_LIST_SUCCESS,
          payload: {
            categories: response.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_CATEGORY_LIST_ERROR,
          payload: {
            categories: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to fetch categories",
          })
        );
      });
  };
}

export function getTagsList() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_TAGS_LIST_PENDING,
      payload: {
        tags: null,
      },
    });
    dispatch(showLoader());

    Api.get("masterData/tagList")
      .then((response) => {
        // console.log("tags", response.data);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_TAGS_LIST_SUCCESS,
          payload: {
            tags: response.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_TAGS_LIST_ERROR,
          payload: {
            tags: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to fetch tags",
          })
        );
      });
  };
}

export function getStatusList() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_STATUS_LIST_PENDING,
      payload: {
        status: null,
      },
    });
    dispatch(showLoader());

    Api.get("masterData/statusList")
      .then((response) => {
        // console.log("tags", response.data);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_STATUS_LIST_SUCCESS,
          payload: {
            status: response.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_STATUS_LIST_ERROR,
          payload: {
            status: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to fetch status",
          })
        );
      });
  };
}

export function getLanguagesList() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_LANGUAGES_LIST_PENDING,
      payload: {
        languages: null,
      },
    });
    dispatch(showLoader());

    Api.get("masterData/languageList")
      .then((response) => {
        // console.log("tags", response.data);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_LANGUAGES_LIST_SUCCESS,
          payload: {
            languages: response.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_LANGUAGES_LIST_ERROR,
          payload: {
            languages: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to fetch languages",
          })
        );
      });
  };
}
export function getYouTubeSourceList() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_YOUTUBE_SOURCE_LIST_PENDING,
      payload: {
        youTubeSourceList: [],
      },
    });
    dispatch(showLoader());

    Api.get("masterData/youtubeSourceList")
      .then((response) => {
        // console.log("tags", response.data);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_YOUTUBE_SOURCE_LIST_SUCCESS,
          payload: {
            youTubeSourceList: response.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_YOUTUBE_SOURCE_LIST_ERROR,
          payload: {
            youTubeSourceList: [],
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to fetch youtube sources",
          })
        );
      });
  };
}

export function addNewTag(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ADD_TAG_PENDING,
      payload: {
        addTagPending: true,
        addTagSuccess: false,
        addTagError: null,
      },
    });
    dispatch(showLoader());

    Api.post("auth/addTag", data)
      .then((response) => {
        if (response.message === "Tag added successfully") {
          dispatch(
            showAlert({
              isOpen: true,
              title: "Success",
              type: "success",
              msg: response.message,
            })
          );
        }
        // console.log("new tag", response.data);
        dispatch(hideLoader());
        dispatch(getTagsList());
        dispatch({
          type: actionTypes.ADD_TAG_SUCCESS,
          payload: {
            addTagPending: false,
            addTagSuccess: true,
            addTagError: null,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_TAG_ERROR,
          payload: {
            addTagPending: false,
            addTagSuccess: false,
            addTagError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function getBannerScreenList() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_BANNER_SCREEN_LIST_PENDING,
      payload: {
        bannerScreenList: [],
      },
    });
    dispatch(showLoader());

    Api.get("masterData/bannerScreen")
      .then((response) => {
        // console.log("tags", response.data);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_BANNER_SCREEN_LIST_SUCCESS,
          payload: {
            bannerScreenList: response.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_BANNER_SCREEN_LIST_ERROR,
          payload: {
            bannerScreenList: [],
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to fetch banner screen list",
          })
        );
      });
  };
}

export function getDeviceList() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_DEVICE_LIST_PENDING,
      payload: {
        deviceList: [],
      },
    });
    dispatch(showLoader());

    Api.get("masterData/deviceList")
      .then((response) => {
        // console.log("tags", response.data);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_DEVICE_LIST_SUCCESS,
          payload: {
            deviceList: response.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_DEVICE_LIST_ERROR,
          payload: {
            deviceList: [],
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to fetch device list",
          })
        );
      });
  };
}

export function getSubscriptionList() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_SUBSCRIPTION_LIST_PENDING,
      payload: {
        subscriptionList: [],
      },
    });
    dispatch(showLoader());

    Api.get("masterData/subscriptionList")
      .then((response) => {
        // console.log("tags", response.data);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_SUBSCRIPTION_LIST_SUCCESS,
          payload: {
            subscriptionList: response.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_SUBSCRIPTION_LIST_ERROR,
          payload: {
            subscriptionList: [],
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function getNotificationTypeList() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_NOTIFICATION_TYPE_LIST_PENDING,
      payload: {
        notificationTypeList: [],
      },
    });
    dispatch(showLoader());

    Api.get("masterData/notificationType")
      .then((response) => {
        // console.log("tags", response.data);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_NOTIFICATION_TYPE_LIST_SUCCESS,
          payload: {
            notificationTypeList: response.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_NOTIFICATION_TYPE_LIST_ERROR,
          payload: {
            notificationTypeList: [],
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function getPlatformsList() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_PLATFORM_PENDING,
      payload: {
        platforms: [],
      },
    });
    dispatch(showLoader());

    Api.get("masterData/platform")
      .then((response) => {
        // console.log("tags", response.data);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_PLATFORM_SUCCESS,
          payload: {
            platforms: response.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_PLATFORM_ERROR,
          payload: {
            platforms: [],
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function getTopicList() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_TOPIC_LIST_PENDING,
      payload: {
        topicList: [],
      },
    });
    dispatch(showLoader());

    Api.get("masterData/topicList")
      .then((response) => {
        // console.log("tags", response.data);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_TOPIC_LIST_SUCCESS,
          payload: {
            topicList: response?.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_TOPIC_LIST_ERROR,
          payload: {
            topicList: [],
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}
